//https://mui.com/components/alert/
import MuiAlert from "@material-ui/lab/Alert";//filled

const Alert = (props) => {
    return <div className="my-3"><MuiAlert elevation={6} variant="outlined" {...props} /></div>;
}
 
export default Alert;